import React, { Component } from 'react';
import Landing from './pages/landing';
import Product from './pages/product';
import Brand from './pages/brands';
import Project from './pages/project';
import Review from './pages/review';
import Team from './pages/team';
import Contact from './pages/contact';

import solarlux from './data/product/solarlux';
import cero from './data/product/cero';
import record from './data/product/record';
import jacc from './data/project/jacc';
import yalda from './data/review/yalda';
import nme from './data/nme';

let countryCode = window.getLocation();

class Main extends Component {
    render() {
        return (
            <div id="fullpage">
                <Landing />
                <Product data={solarlux}/>
                <Product data={cero}/>
                <Product data={record}/>
                <Brand data={record}/>
                <Project data={jacc}/>
                <Review data={yalda}/>
                { countryCode === "KW" ? <Team data={nme}/> : null }
                <Contact data={nme}/>
            </div>
        );
    }
};

export default Main;



// WEBPACK FOOTER //
// ./src/main.js